export const MAX_PERCENT = 100;
export const DEFAULT_PLACEHOLDER = 'N/A';
export const ERROR_MESSAGE = 'The value must not be more than 100';
export const ERROR_MESSAGE_MIN = 'Must be less than MAX parameter';
export const ERROR_MESSAGE_MAX = 'Must be more than MIN parameter';
export const thresholdTitles = ['KPI', 'Min, %', 'Max, %'];
